import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import Select from 'react-select';

const Terminal = (props) => {
  const { user } = props
  const [lockData, setLockData] = useState(false);
  const { siteId, mallId } = useParams();
  const { addToast } = useToasts();

  const [values, setValues] = useState({
    site_id: siteId, 
    mall_id: mallId,
    shop_id: null,
    term_id: null,
    terminal_id: '', 
    terminal_name: '', 
    upd_date: null, 
  });

  const PAGE_SIZE = 5;
  const [terminalData, setTerminalData] = useState(null);
  const [siteTerminalData, setSiteTerminalData] = useState(null);
  const [shopMaster, setShopMaster] = useState(null);
  const [condition, setCondition] = useState({ shop: null });
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshTerminal = useCallback(async () => {
    console.log("refreshTerminal");
    const jwt = localStorage.getItem('jwt');
    // 端末マスタ
    const terminalData = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/terminal/search/`, { site_id: siteId, mall_id: mallId }, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    const siteTerminalData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/terminal/${siteId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    // 店舗マスタ
    const shopData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shop/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data;

    setTerminalData(terminalData);
    setSiteTerminalData(siteTerminalData);
    setShopMaster(shopData);
  }, [siteId, mallId])

  const setConditionValue = (value, name) => {
    setCondition({ ...condition, [name]: value });
  }

  // 登録ボタン：処理
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    // 入力チェック
    if (!data.terminal_id || !data.terminal_id.trim()) {
      window.alert('端末IDを入力してください。');
      return;
    }
    if (!data.terminal_name || !data.terminal_name.trim()) {
      window.alert('端末名を入力してください。');
      return;
    }
    if (!condition.shop) {
      window.alert('店舗を選択してください。');
      return;
    }
    if (data.terminal_id && data.terminal_id.length > 36) {
      window.alert('端末IDは36文字以内で入力してください。');
      return;
    }
    if (data.terminal_name && data.terminal_name.length > 200) {
      window.alert('端末名は200文字以内で入力してください。');
      return;
    }
    
    // 施設間での端末IDの重複チェック
    const isTerminalIdDuplicate = data.upd_date ? 
      siteTerminalData.some(terminal => 
        terminal.terminal_id === data.terminal_id && terminal.term_id !== data.term_id
      )
      :
      siteTerminalData.some(terminal => terminal.terminal_id === data.terminal_id);

    if (isTerminalIdDuplicate) {
      window.alert('既に登録されている端末IDです。');
      return;
    }
    if (!window.confirm(`登録してよろしいですか？`)) {
      return;
    }

    const params = {
      site_id: siteId,
      mall_id: mallId,
      term_id: data.term_id,
      shop_id: condition.shop ? condition.shop.value : null,
      terminal_id: data.terminal_id ? data.terminal_id : null,
      terminal_name: data.terminal_name ? data.terminal_name : null,
      upd_name: user.userId,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/terminal/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshTerminal();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    const selectedShop = shopMaster.find(shop => shop.shop_id === data.shop_id);
    setConditionValue(selectedShop ? { value: selectedShop.shop_id, label: selectedShop.shop_name } : null, "shop");
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      site_id: siteId,
      mall_id: mallId,
      term_id: null,
      shop_id: null,
      terminal_id: "",
      terminal_name: "",
      upd_date: null,
    });
    setCondition({ shop: null });
  }
  
  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.terminal_id === null || data.terminal_id === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.term_id === null || data.term_id === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  // 削除ボタン：処理
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    
    if (!window.confirm(`端末[${data.terminal_id}:${data.terminal_name}]を削除します。よろしいですか？`)) {
      return;
    }

    const params = {
      site_id: siteId,
      mall_id: mallId,
      term_id: data.term_id,
      shop_id: data.shop_id,
      terminal_id: data.terminal_id,
      terminal_name: data.terminal_name,
      user_id: data.user_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/terminal/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshTerminal();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const handleChange = (e) => {
    const target = e.target;
    var value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  // 初期実行トリガー
  useEffect(() => {
    async function fetchData() {
      await refreshTerminal();
    }
    return fetchData();
  }, [refreshTerminal]);

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="terminal_id">端末ID</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" id="terminal_id" name="terminal_id" value={values.terminal_id} onChange ={handleChange} placeholder="端末IDを入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="terminal_name">端末名</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" id="terminal_name" name="terminal_name" value={values.terminal_name} onChange={handleChange} placeholder="端末名を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="terminal_name">店舗</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <Select
              styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
              options={shopMaster ? shopMaster.map(s => ({ value: s.shop_id, label: `${s.shop_name}` })) : []}
              isClearable={true}
              closeMenuOnSelect={true}
              value={condition.shop ? condition.shop : null}
              onChange={(value) => setConditionValue(value, "shop")}
              placeholder="- 選択 -" />
          </div>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">{renderRegistButton(values)}</div>
          <div className="col-3 text-center">{renderDeleteButton(values)}</div>
          <div className="col-3 text-center">{renderResetButton(values)}</div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    const filteredData = terminalData.filter(data =>
      !searchKeyword || data.terminal_id.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3  mt-3 p-0">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="端末IDで絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  端末ID
                </td>
                <td className="text-center align-middle">
                  端末名
                </td>
                <td className="text-center align-middle">
                  店舗
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 && <tr><td colSpan={4} className='text-center'>データがありません</td></tr>}
              {pagedData.map((data) => (
                <tr key={data.terminal_id}>
                  {/* 端末ID */}
                  <td className="text-center align-middle">
                    {data.terminal_id}
                  </td>
                  {/* 端末名 */}
                  <td className="text-center align-middle">
                    {data.terminal_name}
                  </td>
                  {/* 店舗 */}
                  <td className="text-center align-middle">
                    {data.shop_name ? data.shop_name : (data.shop_id && shopMaster ? shopMaster.findIndex(x => x.shop_id === data.shop_id) >= 0 ? shopMaster.find(x => x.shop_id === data.shop_id).shop_name : "" : "")}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {terminalData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {terminalData !== null && (renderList())}
      {terminalData !== null && (renderInput())}
      {/* {renderPreview()} */}
    </div>
  )
}

export default Terminal;